import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaModule } from 'primeng/textarea';
import { TextareaInput } from '../../../models';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-textarea-input',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, TextareaModule, TranslateModule],
    template: `
        <textarea
            id="{{ 'input' + name }}"
            class="form-control"
            pInputTextarea
            [class]="control.inputClass.join(' ')"
            [rows]="control.rows"
            [placeholder]="control.placeholder! | translate"
            [formControl]="control"
        ></textarea>
    `
})
export class TextareaInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: TextareaInput;
}
